[].slice.call(document.querySelectorAll('.faq-section-block .faq-section-item')).forEach(item => {
    item.querySelector('h2').addEventListener('click', () => {
        item.classList.toggle('expanded')
    })
})